import { FilterProps } from "components/Filters";
import { CheckboxListFilter } from "components/Filters/GenericFilters/CheckboxListFilter";

import { useContractDetailsSelects } from "contexts/ContractDetailsSelectsProvider";
import { sortObjectsByProperty } from "./sortFilterOptions";

export const ContractDetailsShipFromFilter = ({ variant }: FilterProps) => {
  const selectStates = useContractDetailsSelects();

  const shipFrom = selectStates.find(
    ({ filterKey }) => filterKey === "shipFrom"
  );

  const shipFromOptions = shipFrom
    ? sortObjectsByProperty(shipFrom.options, "label")
    : [];

  return (
    <CheckboxListFilter
      filterKey="shipFrom"
      name="Ship From"
      variant={variant}
      filterOptions={shipFromOptions}
      maxH="200px"
    />
  );
};
